import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/dg200/');

export default function ImgTextM() {
    const { useLang, isMobile, useEffect, useRouter } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const { locale } = useRouter();

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const textFadeInOut = (el: any) => {
        const target = `.dg200 .imgTextM ${el}`;
        const targetEl = document.querySelector(target) as HTMLElement;
        const targetH = targetEl?.offsetHeight || 100;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: isMobile ? '-.44rem' : '-60px',
            triggerHook: 0,
            duration: targetH,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 0 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        if (!isMobile) {
            textFadeInOut('.title');
        }
    }, []);

    return (
        <div className={`imgTextM ${css.imgTextM} ${isMobile ? 'imgTextM_h5' : 'imgTextM_pc'}`}>
            <p className="title">{t('dg200.imgTextM_title')}</p>
            <div className="img">
                <div className="img-box">
                    <EFPic
                        name={[
                            `${isMobile ? 'h5/' : 'pc/'}13${locale === 'cn' ? `_${locale}` : ''}.webp`,
                            `${isMobile ? 'h5/' : 'pc/'}13${locale === 'cn' ? `_${locale}` : ''}.jpg`,
                        ]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('dg200.imgTextM_title')}
                        aria-label={t('dg200.imgTextM_title')}
                    />
                </div>
                <div className="textBox">
                    <p className="memo">{t('dg200.imgTextM_memo')}</p>
                </div>
                <div className="spots">
                    {[1, 2, 3, 4, 5, 6]?.map((spot: any, key: number) => (
                        <span key={key} className={`spot spot-${spot}`}>
                            {spot}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
